import { ref } from 'vue';

export const isMobile = ref(window.innerWidth <= 768);

// 화면 크기 변경 감지
window.addEventListener('resize', () => {
  isMobile.value = window.innerWidth <= 768;
});

export const checkIsMobile = () => {
  return isMobile.value;
}; 